import { jsx, jsxs } from "react/jsx-runtime";
import PropTypes from "prop-types";
import { useTheme } from "styled-components";
import { motion } from "framer-motion";
import { Icon } from "../icon/icon.es.js";
import { Inline } from "../inline/inline.es.js";
import { InlineItem } from "../inline/inline-item.es.js";
import { Portal } from "@reach/portal";
import { ToastImplWrapper, ToastImplInner } from "./toast-impl.styles.es.js";
const AnimatedToastImplWrapper = motion(ToastImplWrapper);
const propTypes = {
  children: PropTypes.node.isRequired,
  clickable: PropTypes.bool,
  index: PropTypes.number.isRequired,
  onClick: PropTypes.func,
  placement: PropTypes.oneOf(["bottom", "top"]).isRequired,
  variant: PropTypes.oneOf(["error", "feedback", "loading", "info", "success"])
};
const defaultProps = {
  clickable: false,
  onClick: void 0,
  variant: "feedback"
};
const ToastImpl = ({
  children,
  clickable,
  index,
  onClick,
  placement,
  variant
}) => {
  const theme = useTheme();
  const appearance = {
    error: "danger",
    feedback: "dark",
    loading: "dark"
  }[variant] || "light";
  const [iconType, iconColor] = {
    error: ["close-circle", "white"],
    info: ["exclamation-circle", theme.color.yellow6],
    loading: ["spinner", "white"],
    success: ["check-circle", theme.color.green6]
  }[variant] || [];
  return /* @__PURE__ */ jsx(Portal, { "data-bungle-toasts": true, children: /* @__PURE__ */ jsx(
    AnimatedToastImplWrapper,
    {
      role: "alert",
      initial: {
        height: 0,
        opacity: 0,
        [placement]: (index - 1) * 44 + 16
      },
      animate: {
        height: 36,
        opacity: 1,
        [placement]: index * 44 + 16
      },
      exit: {
        height: 0,
        opacity: 0,
        [placement]: (index - 1) * 44 + 16
      },
      $appearance: appearance,
      $clickable: clickable,
      onClick: clickable ? onClick : void 0,
      children: /* @__PURE__ */ jsx(ToastImplInner, { children: /* @__PURE__ */ jsxs(Inline, { space: "small", children: [
        iconType && /* @__PURE__ */ jsx(InlineItem, { children: /* @__PURE__ */ jsx(
          Icon,
          {
            animation: variant === "loading" ? "rotate" : void 0,
            color: iconColor,
            magnitude: "small",
            type: iconType
          }
        ) }),
        /* @__PURE__ */ jsx(InlineItem, { children: /* @__PURE__ */ jsx("span", { children }) })
      ] }) })
    }
  ) });
};
ToastImpl.propTypes = propTypes;
ToastImpl.defaultProps = defaultProps;
export {
  ToastImpl
};
